module.exports = __webpack_public_path__ + "./fonts/EncodeSans-Regular.ttf";